import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BillingService } from '@app/services/billing/billing.service';

/**
 * Keeps a customer whose trial ended unpaid out of the app once the grace
 * period is over. They can still sign in, they just land on the payment screen.
 */
@Injectable({
  providedIn: 'root'
})
export class BillingGuard implements CanActivate {
  constructor(private _billing: BillingService, private router: Router) { }

  canActivate(): Observable<boolean | UrlTree> {
    return this._billing.ensureState().pipe(
      map(state => state.state === 'locked' ? this.router.parseUrl('/payment-required') : true)
    );
  }
}
